<template>
  <ValidationObserver>
    <form ref="form" @submit.prevent="validate" style="height: 100%" class="ma-4">
      <md-toolbar class="md-small md-success">
        <div class="md-toolbar-row">
          <div class="md-toolbar-section-start">
            <md-button class="md-icon-button md-success" @click="addNode">
              <md-icon>post_add</md-icon>
              <md-tooltip>新增节点</md-tooltip>
            </md-button>
            <md-button class="md-icon-button md-success" @click="removeNode">
              <md-icon>delete</md-icon>
              <md-tooltip>删除节点</md-tooltip>
            </md-button>
            <md-button class="md-icon-button md-success" @click="removeEdge">
              <md-icon>layers_clear</md-icon>
              <md-tooltip>删除连接线</md-tooltip>
            </md-button>
            <md-button class="md-icon-button md-success" @click="positionNode">
              <md-icon>ads_click</md-icon>
              <md-tooltip>跳转根节点</md-tooltip>
            </md-button>
            <md-button class="md-icon-button md-success" @click="saveTempateNode">
              <md-icon>filter_none</md-icon>
              <md-tooltip>保存为模板节点</md-tooltip>
            </md-button>
            <md-button class="md-icon-button md-success" @click="openTemplateMarket">
              <md-icon>all_inbox</md-icon>
              <md-tooltip>打开模板商城</md-tooltip>
            </md-button>


            <div v-if="controlFlag" class="contter">
              <!-- <md-button class="md-success btns1" @click="removeAllNode">
              删除所有
              <md-tooltip>删除所有节点</md-tooltip>
            </md-button> -->
              <md-button class="md-success btns1" @click="Addcondition">
                条件节点
                <md-tooltip>条件节点</md-tooltip>
              </md-button>
            </div>
          </div>

          <span class="md-title">{{ taskInfo.name }}</span>
          <div class="md-toolbar-section-end">
            <md-button class="md-icon-button md-success" @click="backTaskPage">
              <md-icon>arrow_circle_left</md-icon>
              <md-tooltip>返回</md-tooltip>
            </md-button>
            <md-button class="md-icon-button md-success" @click="save">
              <md-icon>save_as</md-icon>
              <md-tooltip>保存</md-tooltip>
            </md-button>
          </div>
        </div>
      </md-toolbar>
      <Split :style="{ height: `${flowHeight}px` }">
        <SplitArea :size="form.id ? 75 : 99" ref="taskArea">
          <div style="display: flex; width: 100%; position: relative">
            <div id="container" ref="container" style="flex: 1" :style="{ height: `${flowHeight}px` }"></div>
            <!-- <div style="position:absolute;top:0;right:0;width:300px;height:200px;">
              <div id="miniMap" ref="miniMap" ></div>
            </div> -->
          </div>
        </SplitArea>
        <SplitArea :size="form.id ? 25 : 0" v-show="form.id" style="background: white">
          <collapse :collapse="['基础信息']" icon="keyboard_arrow_down" color-collapse="success" class="md-collapse">
            <template slot="md-collapse-pane-1">
              <md-field>
                <label>编 号</label>
                <md-input v-model="form.id" type="text" disabled> </md-input>
                <span class="md-helper-text">系统自动生成的元件编号</span>
              </md-field>
              <md-field>
                <label>节点类型</label>

                <md-select v-model="form.type" name="type" id="type" :disabled="isCondition"
                  @md-selected="styleChangeWrap">
                  <md-option value="TaskRootNode">初始化节点</md-option>
                  <md-option value="TaskCompositeNode">控制节点</md-option>
                  <md-option value="TaskConditionNode" v-if="isCondition" :disabled="isCondition">条件节点</md-option>
                  <md-option value="TaskActionNode">动作节点</md-option>
                </md-select>
              </md-field>

              <!-- 动作节点高亮 -->
              <md-field v-if="form.type == 'TaskActionNode'">
                <label>控制节点类型</label>

                <md-select v-model="form.TaskActionChild" name="TaskActionChild" id="TaskActionChild"
                  @md-selected="TaskActionStyleChange">
                  <md-option value="TaskActionCamera">摄像机动作节点</md-option>
                  <md-option value="TaskActionHightLight">高亮动作节点</md-option>
                  <md-option value="TaskActionUnHightLight">取消高亮节点</md-option>
                  <md-option value="TaskActionCustom">自定义动作节点</md-option>
                  <md-option value="TaskActionElement">元件操作</md-option>
                  <!-- <md-option value="TaskActionCloseElement">元件隐藏</md-option> -->
                  <md-option value="TaskActionUI">打开UI</md-option>
                  <md-option value="TaskActionVideo">打开视频</md-option>
                  <md-option value="TaskActionCloseVideo">关闭视频</md-option>
                  <md-option value="TaskActionOpenPage">打开页面</md-option>
                  <md-option value="TaskActionClosePage">关闭页面</md-option>
                  <md-option value="TaskActionAudio">打开音频</md-option>
                  <md-option value="TaskActionCloseAudio">关闭音频</md-option>
                  <md-option value="TaskActionPlayPdf">打开PDF</md-option>
                  <md-option value="TaskActionClosePdf">关闭PDF</md-option>
                  <md-option value="TaskActionImage">打开图片</md-option>
                  <md-option value="TaskActionCloseImage">关闭图片</md-option>
                  <md-option value="TaskActionOpenOption">打开选项窗口</md-option>
                  <md-option value="TaskActionCloseOption">关闭选项窗口</md-option>
                  <md-option value="TaskActionOpenTask">任务选择界面</md-option>
                  <md-option value="TaskActionOpenStatisticsOption">打开统计任务</md-option>
                  <md-option value="TaskActionCloseStatisticsOption">关闭统计任务</md-option>
                  <md-option value="TaskActionTeachingAim">显示教学目标</md-option>
                  <md-option value="TaskActionLog">打印日志</md-option>
                </md-select>
              </md-field>


              <md-field v-show="form.TaskActionChild==='TaskActionLog'&&thisNode.getData().typeChild==='TaskActionNode'">
                  <md-input type="text" v-model="form.logInfo" style="text-indent: 4px" placeholder="请输入日志"
                    ></md-input>
                </md-field>
        
              <div v-show="form.TaskActionChild==='TaskActionTeachingAim'&&form.type=='TaskActionNode'">
                <span style="font-size:20px;padding: 5px;color:green; cursor: pointer;" @click="addaimsFn"
                  title="添加任务选择界面">+</span>
                <md-field v-for="item in aimsArr" :key="item.id">
                  <!-- @change="aimsFn" -->
                        <md-input type="text"   v-model="item.value" style="text-indent: 4px" placeholder="请输入教学目标" ></md-input>

                </md-field>

              </div>



              <!-- 元件节点 元件操作 -->
              <div v-show="form.TaskActionChild == 'TaskActionElement'" style="width: 100%">
                <TriggerElement  :tiggertargetPath="tiggertargetPath" ref="triggerElement"  @setELementsData="setELementsData" />
                <div></div>
              </div>
              <!-- 元件节点 -->
              <v-select v-show="form.TaskActionChild == 'TaskActionElement'" @change="ActionomponentOperaFn" :items="[
                { id: 0, name: '元件隐藏' },
                { id: 1, name: '元件显示' },
              ]" item-value="id" item-text="name" v-model="form.elementOperation" label="元件操作"></v-select>

              <!-- 打开Ui -->
              <v-text-field v-show="form.TaskActionChild == 'TaskActionUI'" @change="setUi" label="界面名称 *"
                v-model="form.uiPanelName" :rules="[v => !!v || '界面名称不能为空']"></v-text-field>
              <!-- 打开Ui -->

              <!-- 视频 -->
              <!-- <v-text-field v-if="form.TaskActionChild === 'TaskActionVideo'" label="视频名称 *" @change="setvideoName" v-model="form.videoName"
                :rules="[v => !!v || '视频名称不能为空']"></v-text-field> -->

              <v-text-field v-show="form.TaskActionChild === 'TaskActionVideo'" label="播放时长(秒) *" @change="setvideoTime"
                v-model="form.videoTime" :rules="[v => !!v || '播放时长(秒) 不能为空']"></v-text-field>


              <v-textarea v-show="form.TaskActionChild === 'TaskActionVideo'" v-model="form.attachments" label="视频资源 *"
                rows="1" auto-grow readonly :rules="[(v) => !!v || '视频资源不能为空']"
                @mouseup.native.stop="focusAttachment('1')"></v-textarea>
              <!-- 视频 -->

              <!-- 音频 -->
              <!-- <v-select item-text="label" item-value="value" v-if="form.TaskActionChild === 'TaskActionAudio'" :items="[
              { value: 'backgroundMusic', label: '背景音乐' },
              { value: 'tipsAudio', label: '提示语音' },
              { value: 'actionMusic', label: '动作音效' },
              ]" v-model="form.audioType" label="音频类型 *" :rules="[v => !!v || '音频类型不能为空']"></v-select>

              <v-text-field v-if="form.TaskActionChild === 'TaskActionAudio'" label="音频名称 *" v-model="form.audioName"
              :rules="[v => !!v || '音频名称不能为空']"></v-text-field>

              <v-text-field v-if="form.TaskActionChild === 'TaskActionAudio'" label="播放时长 *" v-model="form.playTime"
              :rules="[v => !!v || '播放时长不能为空']"></v-text-field> -->
              <v-textarea v-show="form.TaskActionChild == 'TaskActionAudio'" v-model="form.attachments" label="音频资源 *"
                rows="1" auto-grow readonly :rules="[(v) => !!v || '音频资源不能为空']"
                @mouseup.native.stop="focusAttachment('2')"></v-textarea>
              <!-- 音频 -->




              <!-- pdf -->

              <v-textarea v-show="form.TaskActionChild == 'TaskActionPlayPdf'" v-model="form.attachments" label="PDF *"
                rows="1" auto-grow readonly :rules="[(v) => !!v || 'PDF资源不能为空']"
                @mouseup.native.stop="focusAttachment('5')"></v-textarea>
              <!-- pdf -->

              <!-- 图片 -->

              <!-- <v-text-field v-if="form.TaskActionChild == 'TaskActionImage'" label="图片名称 *" v-model="form.spriteName"
                :rules="[v => !!v || '图片名称不能为空']"></v-text-field> -->
              <v-row v-show="form.TaskActionChild == 'TaskActionImage'&&thisNode.getData().typeChild==='TaskActionNode'">
                <v-col col="4">
                  <span>坐标 *</span>
                </v-col>
                <v-col col="4">
                  <v-text-field label="x *" v-model="form.spritePositionx"
                    :rules="[v => !!v || 'x坐标 不能为空']"></v-text-field>
                </v-col>
                <v-col col="4">
                  <v-text-field label="y *" v-model="form.spritePositiony"
                    :rules="[v => !!v || 'y坐标 不能为空']"></v-text-field>
                </v-col>
              </v-row>

              <v-row v-show="form.TaskActionChild == 'TaskActionImage'&&thisNode.getData().typeChild==='TaskActionNode'">
                <v-col col="4">
                  <span>宽、高 *</span>
                </v-col>
                <v-col col="4">
                  <v-text-field label="宽 *" v-model="form.spriteSizeWidth" :rules="[v => !!v || '宽 不能为空']"></v-text-field>
                </v-col>
                <v-col col="4">
                  <v-text-field label="宽 *" v-model="form.spriteSizeHeight"
                    :rules="[v => !!v || '高 不能为空']"></v-text-field>
                </v-col>
              </v-row>

              <v-textarea
                      v-show="form.TaskActionChild === 'TaskActionImage'&&thisNode.getData().typeChild==='TaskActionNode'"
                      v-model="form.attachments"
                      label="图片资源 *"
                      rows="1"
                      auto-grow
                      readonly
                      :rules="[(v) => !!v || '图片资源不能为空']"
                      @mouseup.native.stop="focusAttachment('0')"
                    ></v-textarea>

              <!-- 图片 -->

              <ResourceLibrarySelect :dialogEdit.sync="showSelectDialog" :checkMod="resourceList"
                :defaultType="defaultType" :maxNumber="1" @handleCancel="showSelectDialog = false"
                @handleSubmit="handleSelectSubmit" />


              <div v-show="form.TaskActionChild == 'TaskActionOpenOption'">
                <md-field>
                  <md-input type="text" v-model="question" style="text-indent: 4px" placeholder="请输入问题"
                    @input="setQuestion"></md-input>
                </md-field>
                <div v-for="item in checkBox" :key="item.id">
                  <md-checkbox v-model="item.isCheck" @change="filterCheckBox"
                    style="margin-right: 2px !important; vertical-align: middle">{{ item.name }}</md-checkbox>
                  <md-field style="display: inline-block; width: 72% !important">
                    <md-input type="text" v-model="item.value" style="text-indent: 4px" placeholder="请输入"
                      @change="filterInputBox($event, item.id)"></md-input>
                  </md-field>
                </div>
                <md-field>
                  <label>答案:</label>
                  <md-radio v-for="(item, index) in OpenOptionCondition" :key="index" v-model="answer" :value="item"
                  @change="setCheckRadio" class="OpenOptionCondition" style="margin-top:37px;">{{ item }}</md-radio>
                </md-field>

          
                <md-field>
                  <label>解析:</label>
                  <md-input type="text" v-model="analysis" style="text-indent: 4px" placeholder="请输入解析"
                    @input="setAnalysis"></md-input>
                </md-field>
              </div>

              <!-- 控制节点 -->
              <md-field v-show="form.type == 'TaskCompositeNode'">
                <label>控制节点类型</label>
                <md-select v-model="form.typeChild" name="typeChild" id="typeChild" @md-selected="styleChange">
                  <md-option value="TaskSequenceNode">顺序节点</md-option>
                  <md-option value="TaskSelectorNode">选择节点</md-option>
                  <md-option value="TaskParallelNode">并行节点</md-option>
                </md-select>
              </md-field>
              <!-- 控制节点 -->

              <!-- 顺序节点 -->
              <md-field v-show="form.typeChild == 'TaskSequenceNode'||form.type=='TaskCompositeNode'">
                <md-input type="text" v-model="teachingActivity"  placeholder="请输入任务选择"
                  @change="teachingActivityFn"></md-input>
              </md-field>
              <!-- 顺序节点 -->



              <!-- 条件节点 -->
              <div v-show="form.type == 'TaskConditionNode'" style="width: 100%">
                <Trigger v-show="form.id" ref="trigger" @updateTrigger="updateTrigger" :tiggerFlag="tiggerFlag"
                  @settrigger="settrigger" @setExamArr="setExamArr"  @setExamSettle="setExamSettle" />
                <div></div>
              </div>
              <!-- 条件节点 -->

              <md-field
                v-show="form.type == 'TaskConditionNode' && thisNode.getData().typeChild == 'TaskConditionTask' || ConditionTaskFlag">

                <md-input type="text" v-model="ConditionTaskSelect" style="text-indent: 4px" placeholder="请输入任务选择"
                  @change="setTaskSlectFn"></md-input>
              </md-field>


              <div v-show="form.type == 'TaskConditionNode' &&
                TaskConditionFlag == true
                " style="text-align: center">
                <md-radio v-for="(item, index) in checkBoxCondition" :key="index" v-model="radio" :value="item"
                  @change="filterCondition">{{ item }}</md-radio>
              </div>
              <!-- 动作节点任务选择 -->
              <div v-show="form.type == 'TaskActionNode' && form.TaskActionChild == 'TaskActionOpenTask'">
                <span style="font-size:20px;padding: 5px;color:green; cursor: pointer;" @click="addActionTasks"
                  title="添加任务选择界面">+</span>
                <md-field v-for="item in addActionTasksList" :key="item.id">
                  <!-- <span>路径信息</span> -->
                  <md-input type="text" v-model="item.value" style="text-indent: 4px;margin-left: 10px;"
                    placeholder="请输入任务选择信息"></md-input>
                  <span style="font-size:20px;padding: 5px;color:red; cursor: pointer;" @click="delActionTasks(item)"
                    title="添加任务选择界面">-</span>
                </md-field>
              </div>
              <!-- 动作节点任务选择 -->

              <md-field>
                <label>名 称</label>
                <md-input v-model="form.label" type="text"> </md-input>
                <span class="md-helper-text">请使用英文/字符,首字母不要使用字符</span>
              </md-field>

              <div v-show="form.type == 'TaskConditionNode' && rightNameFlag">

                <md-field>
                  <label>正确名称</label>
                  <md-input type="text" v-model="rightName" style="width:75%; margin-left: 2%;" placeholder="请输入正确名称"
                    @change="setrightName"></md-input>
                  <span style="font-size:18px;padding: 5px;color:red; cursor: pointer;" @click="addModels"
                    title="添加模型">+</span>
                </md-field>
                <div v-for="item in rightData" :key="item.id">
                  <md-field>
                    <span>模型名称</span>
                    <md-input type="text" v-model="item.modelName" style="text-indent: 4px;width: 90%;margin-left: 10px;"
                      placeholder="请输入模型的名字"></md-input>
                  </md-field>
                  <span style="font-size:18px;padding: 5px;color:red; cursor: pointer;" title="添加标注信息"
                    @click="addchildMsg(item)">+</span>
                  <div v-for="items in item.marks" style="width: 80%; float: right;" :key="items.id">
                    <span style="font-size:18px;padding: 5px;color:red; cursor: pointer;" title="删除标注信息"
                      @click="delchildMsg(item, items)">-</span>
                    <md-field>
                      <span>路径信息</span>
                      <md-input type="text" v-model="items.path" style="text-indent: 4px;margin-left: 10px;"
                        placeholder="请输入路径信息"></md-input>
                    </md-field>
                    <md-field>
                      <span>标注信息</span>
                      <md-input type="text" v-model="items.desc" style="text-indent: 4px;margin-left: 10px;"
                        placeholder="请输入标注信息"></md-input>
                    </md-field>

                  </div>
                </div>
              </div>






              <md-field>
                <label>描 述</label>
                <md-textarea v-model="form.description" md-autogrow></md-textarea>
                <span class="md-helper-text">请输入功能说明，回车可换行</span>
              </md-field>

              <md-card style="margin-top: 20px" v-show="form.type == 'TaskActionNode' || isConditionFlag">
                <md-card-content>
                  <!-- 步骤表单 -->
                  <!-- <TaskStepForm ref="stepForm" :showExtDialog.sync="showExtDialog" @confirm="stepConfirm">
                  </TaskStepForm> -->
                  <v-form ref="form" @submit.prevent="confirm">
                    <v-card class="window-card">
                      <v-form v-model="valid" class="px-10">
                        <!-- 条件节点 -->


                        <SceneMetaTab v-if="form.TaskActionChild == 'TaskActionHightLight' ||
                          form.TaskActionChild == 'TaskActionUnHightLight' ||
                          form.TaskActionChild == 'TaskActionCustom' ||
                          form.TaskActionChild == 'TaskActionOpenPage' ||
                          form.TaskActionChild == 'TaskActionClosePage'
                          " ref="editor" :isOpenPage="isOpenPage" @setTargePath="setTargePath" @setBoolea="setBoolea"
                          @setPageInsk="setPageInsk" />

                        <SystemMetaTab v-if="form.TaskActionChild == 'TaskActionCamera'" ref="system"
                          @setActionFormCamera="setActionFormCamera" />
                        <v-text-field v-model="formData.stepTime" label="步骤时间 *" type="number" @change="setTargePath1"
                          :rules="[(v) => !!v || '步骤时间不能为空']" hint="请使用整数类型，单位秒（s）"></v-text-field>
                        <!-- <v-text-field v-model="formData.stepOrder" type="number" label="步骤顺序"
                        hint="请使用阿拉伯数字"></v-text-field> -->
                      </v-form>
                    </v-card>
                  </v-form>
                </md-card-content>
              </md-card>
            </template>
          </collapse>
        </SplitArea>
      </Split>
    </form>

    <TaskTemplateInfo />
  </ValidationObserver>
</template>
<script>
import { Collapse, Pagination } from "@/components";
import { listSysComponent } from "@/api/component/sys_component";
import { findTypeListBySceneId } from "@/api/device";
import Trigger from "./components/Trigger";
import TriggerElement from "./components/TriggerElement";
import GraphInit from "./components/GraphOption";
import TaskStepForm from "./components/TaskStepForm";
import { innerAction } from "./../SystemAction";
import { sceneAction } from "./../SceneAction";
import { innerAction as RoleAction } from "./../RoleAction";
import Swal from "sweetalert2";
import { getTaskInfo } from "@/api/task/task";
import { queryTreeData } from "@/api/device";
import { queryCameraPositionList } from "@/api/editor/editor";
import { actionTypeMap } from "@/utils/dict";
import { tabType } from "./components/TabType";
import SystemMetaTab from "./Tab/SystemMetaTabCopy";
import SceneMetaTab from "./Tab/SceneMetaTabCopy";
import TaskTemplateInfo from "../TaskTemplateInfo.vue";
import {
  saveTreeJsonData,
  queryTreeJsonData,
  setConfigDatas,
} from "@/api/task/task";
let graph = {};
import { mapGetters } from "vuex";

import ResourceLibrarySelect from "@/components/Resource/ResourceLibrarySelect";
import { uuid } from '@antv/x6/lib/util/string/uuid';
const stepTypeMap = {
  device: "设备",
  tool: "工具",
  role: "角色",
  scene: "场景",
  system: "系统",
  editor: "任务场景",
};

export default {
  data() {
    return {
      aims:'', //教学目标
      aimsArr:[],
      teachingActivity:"",//顺序节点
      tiggertargetPath:"",
      logicConfig: '',
      ConditionTaskFlag: false,
      ConditionTaskSelect: "",
      addActionTasksList: [],
      rightName: "",
      rightNameFlag: false,
      rightData: [
        // {
        // id:uuid(),
        // "modelName": "",  // UI：在模型资源库选择模型，获取模型的名字
        // "marks": [
        // ]
        // }
      ],
      tiggerFlag: false,
      isConditionFlag: false,
      resourceList: [],
      defaultType: "",
      showSelectDialog: false,
      isOpenPage: 'noOpenPage',
      question: "",
      answer:'',   //答案
      analysis:'', //解析
      radio: "",
      checkBox:[{
          id: "1",
          isCheck: false,
          value: "",
          name: "chooseA",
        },
        {
          id: "2",
          isCheck: false,
          value: "",
          name: "chooseB",
        },
        {
          id: "3",
          isCheck: false,
          value: "",
          name: "chooseC",
        },
        {
          id: "4",
          isCheck: false,
          value: "",
          name: "chooseD",
        }
      ],
      checkBoxCondition: [
        "A",
        "B",
        "C",
        "D",
      ],
      OpenOptionCondition:[
        "A",
        "B",
        "C",
        "D",
      ],
      formData: {
        type: "editor",
        stepTime:0,
      },
      TaskConditionFlag: false,
      tab: "",
      valid: false,
      tabType,

      isCondition: false,
      conditionFlag: "",
      controlFlag: false, //控制节点
      TaskConditionNode: false, //条件节点
      thisNode: null,
      headers: [
        { text: "对象", align: "center", value: "_id" },
        { text: "动作", align: "center", value: "templateId" },
        { text: "类型", align: "center", value: "type" },
        { text: "编辑", align: "center", value: "option", width: "100px" },
      ],
      form: {},
      checkedEdgeId: "",
      showExtDialog: false,
      stepTypeMap,
      tableData: [],
      currentSort: "name",
      currentSortOrder: "asc",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      stepPage: {
        perPage: 1000,
        currentPage: 1,
      },
      stepMetaMap: {},
      stepActionMap: {},
      flowMapData: {},
      flowTriggerMap: {},
      searchQuery: "",
      propsToSearch: ["name"],
      searchedData: [],
      fullScreenStatus: false,
      flowHeight: 699,
      chooseNodeId: "",
      taskInfo: {},
      uiPageMap: {},
    };
  },
  components: {
    Collapse,
    Pagination,
    TaskStepForm,
    Trigger,
    TriggerElement,
    SceneMetaTab,
    SystemMetaTab,
    ResourceLibrarySelect,
    TaskTemplateInfo,
  },
  computed: {
    // ...mapGetters(["project", "showProjectEdit", "course", "sceneList"]),
    ...mapGetters(["stepForm", "course", 'sceneList']),

    dialogShowStatus: {
      get() {
        this.formData = {
          type: "editor",
        };
        return this.showExtDialog;
      },
      set(val) {
        this.$emit("update:showExtDialog", val);
      },
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.tableData.length;
    },
  },
  methods: {

    setExamArr(data){
      this.thisNode.setData({json:JSON.stringify(data)})
    },
    setExamSettle(data){
        this.thisNode.setData({settleType:data})
    },

    //添加教学目标
    addaimsFn(){
      this.aimsArr.push({
         id:uuid(),
         value:''
      })


    },
    saveTempateNode() {
      this.$store.commit('taskTemplate/SET_FORM_STATUS', true)
    },
    openTemplateMarket() {

    },
    setTaskSlectFn(e) {
      this.thisNode.setData({ 'choose': e.target.value })
    },
    teachingActivityFn(e){
      this.thisNode.setData({'teachingActivity': e.target.value })
    },
    // aimsFn(e){
    //   this.thisNode.setData({'aims': e.target.value })
    // },
    addActionTasks() {

      this.addActionTasksList.push({
        id: uuid(),
        value: ""
      })

    },
    delActionTasks(item) {
      this.addActionTasksList = this.addActionTasksList.filter(items => items.id !== item.id)

    },
    setrightName(e) {
      this.thisNode.setData({ 'rightName': e.target.value })
    },
    addchildMsg(item) {
      item.marks.push(
        {
          id: uuid(),
          "path": "",  // 模型子节点的路径
          "desc": "" // 用户输入描述
        })


    },
    //删除标注信息
    delchildMsg(item, items) {
      let ids = item.id;
      let thisItem = item.marks.filter(item => item.id !== items.id)
      this.rightData && this.rightData.forEach(item1 => {
        if (item1.id == ids) {
          item1.marks = thisItem
          this.$set(item1, item1.marks, thisItem)
        }
      })


    },
    addModels() {
      this.rightData.push({
        id: uuid(),
        "modelName": "",  // UI：在模型资源库选择模型，获取模型的名字
        "marks": []
      })
    },
    setUi(data) {
      this.thisNode.setData({ "uiPanelName": data })
    },
    setvideoName(data) {
      this.thisNode.setData({ 'videoName': this.form.videoName })
    },
    setvideoTime(data) {
      this.thisNode.setData({ 'videoTime': this.form.videoTime })
    },
    // 资源弹窗
    focusAttachment(type) {
      this.defaultType = type;
      this.showSelectDialog = true;
      // 解决第一次弹窗闪屏问题
      setTimeout(() => {
        this.showSelectDialog = true;
      }, 100);
      this.resourceList = this.form.attachment_url;
    },

    handleSelectSubmit(checkList) {

      this.resourceList = checkList;
      this.form.attachment_url = checkList.map((item) => {
        return {
          _id: item._id,
          name: item.name,
          fullPath: item.fullPath
        };
      });

      this.form.attachments = checkList.map((item) => item.name).join(",");
      let url = this.form.attachment_url[0].fullPath;
      let audioName = this.form.attachment_url[0].name;

      this.thisNode.setData({ "resourceUrl": url, 'attachments': this.form.attachments })

      this.showSelectDialog = false;

    },
    //设置选项窗口节点问题
    setQuestion() {
      this.thisNode.setData({ "question": this.question })
    },

    //设置选项窗口节点问题
    setAnalysis() {
      this.thisNode.setData({ "analysis": this.analysis })
    },

    //设置选项窗口节点答案
    filterCheckBox(data) {
      let arrs = this.checkBox.filter((item) => item.isCheck == true);
      let obj = {};
      for (let key in arrs) {
        obj[arrs[key]["name"]] = arrs[key]["value"];
      }

      ["chooseA", "chooseB", "chooseC", "chooseD"].forEach((item) => {
        if (this.thisNode.getData().hasOwnProperty(item)) {
          delete this.thisNode.getData()[item];
        }
      });
      this.thisNode.setData(obj);
    },

    filterInputBox(data, id) {
      this.checkBox[id - 1]["value"] = data.target._value;
      this.filterCheckBox();
    },

    filterCondition(data) {
      let obj = {
        answer: data,
      };
      this.thisNode.setData(obj);
    },

    setCheckRadio(data){
      let obj = {
        answer: data,
      };
      this.thisNode.setData(obj);
    },
    setBoolea(data) {
      this.thisNode.setData({ "paramValue": data });
    },

    setTargePath(data) {
      data.runTime = this.formData.stepTime;
      data.targetPath = data.targetPath;
      data.pageId = data.pageId
      data.pageInsKey = data.pageInsKey
      this.thisNode.setData(data);
      this.$forceUpdate();
    },
    setPageInsk(data) {
      this.thisNode.setData(data);
    },



    setActionFormCamera(data) {
      if (data) {
        const {
          positionx,
          positiony,
          positionz,
          quaternionx,
          quaterniony,
          quaternionz,
          quaternionw,
          moveType,
          pyTime,
          allPerspectivesId,
          allPerspname,
        } = data;
        let obj = {
          camPos: [positionx, positiony, positionz], // 位置
          camQuaternion: [quaternionx, quaterniony, quaternionz, quaternionw], //角度
          camMoveType: moveType, //移动模式
          camMoveTime: pyTime, //移动时长
          allPerspectivesId, //视角ID
          allPerspname, //视角名称
        };
        this.thisNode.setData(obj);
      }
    },

    setTargePath1(data) {
      this.thisNode.setData({ runTime: data });
    },

    formInit(form) {
      let that = this;
      that.formData = {};
      that.formData = Object.assign(
        {
          type: "editor",
        },
        this.stepForm
      );
      that.$nextTick(() => {
        that.$refs[that.formData.type].init(that.formData ?? {});
      });
    },
    Addcondition() {
      if (this.thisNode && this.thisNode.getData) {
        if (
          this.thisNode.getData().type == "TaskActionNode" ||
          this.thisNode.getData().typeChild == "TaskActionNode"
        ) {
          this.$store.dispatch("task/noNest");
          return;
        }
      }
      this.addSelectNode("TaskConditionNode");
    },
    styleChange(data) { },
    //动作节点子节点
    TaskActionStyleChange(data) {
      switch (data) {
        case 'TaskActionOpenPage':
          this.isOpenPage = 'TaskActionOpenPage'
          break;
         case 'TaskActionClosePage':
          this.isOpenPage = 'TaskActionClosePage'
          break;

         case 'TaskActionOpenOption':
          break;

          default:
          this.isOpenPage = 'TaskActionClosePage'
          break;


// 



      }
    },


    //判断选中类型
    setActiveType(type) {

    },
    ActionomponentOperaFn(data) {
      this.thisNode.setData({ 'elementOperation': data })
    },
    styleChangeWrap(data) {
      if (data == "TaskActionNode") {
        this.thisNode.getData().typeChild = "TaskActionNode";
      } else if (data == "TaskRootNode") {
        this.thisNode.getData().typeChild = "TaskRootNode";
      }
    },
    backTaskPage() {

      this.$router.push({ name: "design" });
      setTimeout(()=>{
      
        this.$EventBus.$emit('setSwitchFlag',window.localStorage.getItem('switchFlag'))
      },1000)
       
      // this.$EventBus.$emit('checkGroupItem',this.taskInfo)  

     

    },
    positionNode() {
      const cells = graph
        .getCells()
        .filter((item) => item.store.data.shape === "dag-node");
      graph.centerCell(cells[0]);
    },
    setVuexStepForm(form) {
      this.$store.dispatch("task/setStepForm", form);
    },
    editStep(item) {
      this.showExtDialog = true;
      this.setVuexStepForm(item);
      this.$nextTick(() => {
        this.formInit();
      });
    },
    handleAddStep() {
      this.showExtDialog = true;
      this.setVuexStepForm({});
      this.$nextTick(() => {
        this.formInit();
      });
    },
    sortByStepKey(array, key) {
      return array.sort(function (a, b) {
        var x = a[key]; //如果要从大到小,把x,y互换就好
        var y = b[key];
        return x < y ? -1 : x > y ? 1 : 0;
      });
    },
    containFun() {
      this.radio = "";
      let nodeData = this.thisNode.getData();
      if (nodeData.answer) this.radio = nodeData.answer;

      if (
        nodeData.TaskConditionFlag &&
        nodeData.TaskConditionFlag == "selectTrigger") {
        this.TaskConditionFlag = true
      } else {
        this.TaskConditionFlag = false
        this.radio = "";
      }


      //条件节点点击打开页面     
      if (nodeData.typeChild == "TaskConditionOpenPage") {
        if (nodeData.TaskConditionFlag == 'OpenUi') {
          this.tiggerFlag = true
          setTimeout(() => { this.$refs.trigger.filterDataTigger = nodeData.targetPath; this.$refs.trigger.checkNode(nodeData.targetPath) }, 400)
        }

      } else {
        this.tiggerFlag = false
      }

      if (nodeData.typeChild == "TaskConditionChooseModel") {
        this.rightNameFlag = true
        this.rightName = ""
        this.rightData = []
        this.rightName = nodeData.rightName ? nodeData.rightName : ''
        this.rightData = nodeData.json ? JSON.parse(nodeData.json) : []
      } else {
        this.rightNameFlag = false
      }

      if (nodeData.typeChild == "TaskConditionOption") {
        this.TaskConditionFlag = true
      } else {
        this.TaskConditionFlag = false
      }

      if (nodeData.typeChild == "TaskConditionTask") {
        this.ConditionTaskFlag = true
        this.ConditionTaskSelect = nodeData.choose
      }

      if (nodeData.typeChild !== "TaskConditionTask") {
        this.ConditionTaskFlag = false
      }

      if (nodeData.typeChild == "TaskConditionHand") {
            this.$nextTick(()=>{
             this.$refs.trigger.trigger='HandTrigger'
            })
      }

      if (nodeData.typeChild == "TaskConditionClickObject") {
              this.$nextTick(()=>{
                this.$refs.trigger.trigger='Click'
                this.$refs.trigger.triggerClickTarget  = ""
              })
          
            setTimeout(()=>{
              this.$refs.trigger.triggerClickTarget = nodeData.targetPath; 
              this.$refs.trigger.checkNode(nodeData.targetPath)
            },200)
       
    
      }
     
      //考试任务
      if(nodeData.typeChild == "TaskConditionExam"){
            if( nodeData.hasOwnProperty('json')){
              let datas = JSON.parse(nodeData.json) 
              datas.forEach(item=>{
                  item.id=uuid();
                      item.checkBox=[
                      {
                        id: "1",
                        isCheck: false,
                        value: "",
                        name: "chooseA",
                      },
                      {
                        id: "2",
                        isCheck: false,
                        value: "",
                        name: "chooseB",
                      },
                      {
                        id: "3",
                        isCheck: false,
                        value: "",
                        name: "chooseC",
                      },
                      {
                        id: "4",
                        isCheck: false,
                        value: "",
                        name: "chooseD",
                      }
                      ]
                      item.checkBox[0].value  = item.chooseA
                      item.checkBox[1].value  = item.chooseB
                      item.checkBox[2].value  = item.chooseC
                      item.checkBox[3].value  = item.chooseD
                      item.checkBoxCondition = this.checkBoxCondition
              })

              this.$refs.trigger.examArrs = datas

            }
      }

      if(nodeData.typeChild == "TaskConditionExamSettle"){  //考核结算
        // settleType
        if(nodeData.hasOwnProperty('settleType')) this.$refs.trigger.ExamSettle = '';  this.$refs.trigger.ExamSettle = nodeData.settleType;
      }



      //  else{
      //   this.ConditionTaskFlag =false
      //  }

      //  this.ConditionTaskFlag = false



    },
    updateTrigger(triggerObj) {

      if (triggerObj.hasOwnProperty("checkComponentId")) this.thisNode.setData({ "pageId": triggerObj.pageId, "pageInsKey": triggerObj.pageInsKey, "checkComponentId": triggerObj.checkComponentId })
      if (!triggerObj.hasOwnProperty("trigger")) return


      this.flowTriggerMap[this.form.id] = triggerObj;
      if (triggerObj.trigger == "HandTrigger") {
        this.thisNode.setData({ typeChild: "TaskConditionHand" });
      } else if (triggerObj.trigger == "Click") {
        //点击
        if (triggerObj.trigger && triggerObj.trigger == "Click") {
          this.thisNode.setData({ targetPath: triggerObj.deviceName });
          this.thisNode.setData({ typeChild: "TaskConditionClickObject" });
        }
        this.thisNode.setData({ typeChild: "TaskConditionClickObject" });
        // this.TaskConditionFlag = false
      } else if (triggerObj.trigger == "selectTrigger") {
        this.thisNode.setData({ "TaskConditionFlag": "selectTrigger", typeChild: "TaskConditionOption" });
        // this.tiggerFlag = false

        this.TaskConditionFlag = true

      } else if (triggerObj.trigger == "ChooseModel") {  //模型
        this.thisNode.setData({ "TaskConditionFlag": "ChooseModel", typeChild: "TaskConditionChooseModel" })
        // this.isConditionFlag = false
        this.rightNameFlag = true
        //  this.isConditionFlag = true
      } else if (triggerObj.trigger == "OpenUi") {  //打开界面
        this.tiggerFlag = true

        this.thisNode.setData({
          typeChild: "TaskConditionOpenPage",
          "TaskConditionFlag": "OpenUi",
          "pageId": triggerObj.pageId,
          "pageInsKey": triggerObj.pageInsKey,
          "checkComponentId": triggerObj.checkComponentId,
          "targetPath": triggerObj.deviceName
        });

        this.isConditionFlag = false
        this.isConditionFlag = true

      } else if (triggerObj.trigger == "taskSelect") {
        this.thisNode.setData({
          typeChild: "TaskConditionTask",
          "TaskConditionFlag": "taskSelect",
        });

        this.ConditionTaskFlag = true
      }else if(triggerObj.trigger == "TaskConditionExam"){  //考试任务
        this.thisNode.setData({ "TaskConditionFlag": "TaskConditionExam", typeChild: "TaskConditionExam" })

      }else if(triggerObj.trigger == "TaskConditionExamSettle"){  //考核结算
          this.thisNode.setData({ "TaskConditionFlag": "TaskConditionExamSettle", typeChild: "TaskConditionExamSettle" })
      }
      if (triggerObj.trigger !== "taskSelect") {
        this.ConditionTaskFlag = false
      }
      // this.tiggerFlag = false
      if (triggerObj.trigger !== "OpenUi") {
        this.tiggerFlag = false
      }

      if (triggerObj.trigger !== "ChooseModel") {
        this.rightNameFlag = false
      }

      if (triggerObj.trigger !== "selectTrigger") {
        this.TaskConditionFlag = false
      }



      //   if(nodeData.typeChild=="TaskConditionChooseModel"){
      //     this.rightNameFlag = true
      //     this.rightName = ""
      //     this.rightData = []
      //     this.rightName = nodeData.rightName
      //     this.rightData = JSON.parse(nodeData.json); 
      // }else{
      //   this.rightNameFlag = false
      // }


    },
    settrigger(data) {
      this.thisNode.setData({ 'targetPath': data })
    },
    setELementsData(data) {
      this.thisNode.setData({ 'targetPath': data });
    },

    initFlow(taskInfo) {
      this.flowMapData = taskInfo.flowMapData ?? {};
      this.flowTriggerMap = taskInfo.flowTriggerMap ?? {};
      if (taskInfo.flowJsonData) {
        graph.fromJSON(taskInfo.flowJsonData);
        const rootNodes = graph.getRootNodes();
        if (rootNodes && rootNodes.length > 0) {
          // graph.centerContent()
          graph.centerCell(rootNodes[0]);
        }
      }
    },
    async initStepMapData() {
      const sysRes = await listSysComponent(this.stepPage);
      const deviceRes = await findTypeListBySceneId({
        // sceneId: this.taskInfo.taskEditor,
        // type: "editor",
        // projectId: this.taskInfo.project,
        courseId: this.taskInfo.course?this.taskInfo.course:''
      });

      let list = []
        .concat(sysRes.data.rows)
        .concat(innerAction)
        .concat(RoleAction)
        .concat(sceneAction);

      const deviceTypeList = deviceRes.data;

      const action_list = list
        .flatMap((item) => item.action_list)
        .concat(
          deviceTypeList.flatMap((item) =>
            item.deviceTypeInfo ? item.deviceTypeInfo.actions : []
          )
        );

      list = list.concat(deviceTypeList);

      deviceTypeList.reduce((map, item) => {
        map[item.structId] = item.deviceTypeInfo
          ? item.deviceTypeInfo.interface
          : [];
        return map;
      }, this.uiPageMap);

      this.stepMetaMap = list.reduce((pre, next) => {
        pre[next._id] = next.name;
        return pre;
      }, {});

      this.stepActionMap = action_list.reduce((pre, next) => {
        pre[next.id] = next.name;
        return pre;
      }, {});

      const actionData = action_list.reduce((pre, next) => {
        pre[next.id] = next;
        return pre;
      }, {});

      let mapData = this.flowMapData;
      for (let taskId in mapData) {
        let taskNodeActionArr = mapData[taskId];
        // taskNodeActionArr.map((item) => {
        //   if (item.type !== 'system') {
        //     Object.assign(item.actionData, actionData[item.actionData.id])
        //     item.templateName = actionData[item.actionData.id].name
        //   }
        //   return item
        // })
        mapData[taskId] = taskNodeActionArr;
      }

      this.flowMapData = mapData;
      Object.assign(this.stepActionMap, actionTypeMap);

      this.stepActionMap["OpenUI"] = "打开UI";
      this.stepActionMap["CloseUI"] = "关闭UI";
      this.stepActionMap["PlayVideo"] = "打开视频";
      this.stepActionMap["PlayAudio"] = "播放音频";
      this.stepActionMap["Delay"] = "延时";
      this.stepActionMap["MoveCamera"] = "移动摄像机";
      this.stepActionMap["Effects"] = "特效";
    },
    init() {
      graph = GraphInit(document.getElementById("container"));
      graph.on("edge:connected", ({ edge }) => {
        const targetCell = graph.getCellById(edge.target.cell)
        targetCell.data.parentId = edge.source.cell
        edge.attr({
          line: {
            strokeDasharray: "",
          },
        });
      });

      graph.on("edge:click", ({ edge }) => {
        _this.checkedEdgeId = edge.id;
      });


      const _this = this;
      graph.on("node:click", (obj) => {
        const { node } = obj;

        // graph.centerCell(node)
        _this.form = node.getData();
        _this.thisNode = node;
        // ConditionTaskFlag
        this.clearOpenOption()
         if(_this.thisNode.getData().typeChild=="TaskSequenceNode"){
             this.teachingActivity = _this.thisNode.getData().teachingActivity;
         }
        if (_this.thisNode.getData().type !== "TaskConditionNode") {
          this.ConditionTaskFlag = false;
        }
        if (
          _this.thisNode.getData() &&
          _this.thisNode.getData().type == "TaskConditionNode"
        ) {
          _this.isCondition = true;
          _this.form.type = "TaskConditionNode";

          if (_this.form.type == "TaskConditionNode") {
            this.containFun();
          }
        } else if (
          _this.thisNode.getData() &&
          _this.thisNode.getData().type == "TaskActionNode"
        ) {
          //动作节点
          _this.formData.stepTime = _this.thisNode.getData().runTime;
          _this.formData.stepTime = _this.thisNode.getData().runTime;
          if (this.form.TaskActionChild == "TaskActionCamera") {
            //摄像机动作节点
            this.$nextTick(() => {
              _this.$refs["system"].setForm(_this.thisNode.getData());
            });
          } else {

            if (this.form.TaskActionChild == "TaskActionOpenOption") {  //选项窗口节点
              //选项窗口节点前清空值
              this.clearOpenOption()
              let nodeData = this.thisNode.getData();
              for (var key in nodeData) {
                this.checkBox.forEach((item) => {
                  if (key == item.name) {
                    item.value = nodeData[key];
                    item.isCheck = true;
                  }
                });
              }
              if (nodeData.question) this.question = nodeData.question;
              if (nodeData.answer) this.answer = nodeData.answer;
              if (nodeData.analysis) this.analysis = nodeData.analysis;
            }

            setTimeout(() => {
              if (_this.$refs["editor"]) {
                if (this.form.TaskActionChild == 'TaskActionCustom') {  //自定义操作
                  let nodeData = this.thisNode.getData()
                  if (nodeData && nodeData.hasOwnProperty('paramValue')) {
                    setTimeout(() => {
                      this.$refs.editor.setDefeatValue(nodeData.paramValue)
                    }, 100)
                  }
                }
                _this.$refs["editor"].setAdtiveData(_this.thisNode.getData());
                if (_this.thisNode.getData().targetPath) {

                  _this.$refs.editor.checkNode(
                    _this.thisNode.getData().targetPath
                  );
                  _this.$refs.editor.setPage(_this.thisNode.getData())
                  _this.$refs.editor.filterData =
                    _this.thisNode.getData().targetPath;
                } else {
                  _this.$refs.editor.filterData = "";
                }
              }
            }, 200);
          }

          if (_this.thisNode.getData().targetPath) {
            if (_this.form.TaskActionChild !== "TaskActionCamera") {
              //摄像机动作节点
              setTimeout(() => {
                //此处也可用 $nextTick 但是会引起子页面加载问题
                if (_this.$refs.editor) {
                  _this.$refs.editor.checkNode(
                    _this.thisNode.getData().targetPath
                  );
                  _this.$refs.editor.filterData =
                    _this.thisNode.getData().targetPath;
                }
              }, 200);
            }
          }

          this.isActiveTypeFn()
        } else {
          this.isCondition = false;
        }

        _this.form.id = node.id;
        _this.tableData = _this.flowMapData[node.id]
          ? _this.flowMapData[node.id]
          : [];
        // _this.$nextTick(() => {


        //   // _this.$refs.trigger.init(_this.flowTriggerMap[node.id] ?? {});
        // });
        setTimeout(() => {
          if (_this.$refs.trigger) {
            _this.$refs.trigger &&
              _this.$refs.trigger.init(_this.flowTriggerMap[node.id] ?? {});

          }
        }, 200)

        _this.$forceUpdate();
        if (_this.form.type && _this.form.type == "TaskRootNode") {
          _this.controlFlag = true;
          _this.TaskConditionNode = false;
        } else {
          _this.controlFlag = true;
          _this.TaskConditionNode = true;
        }
      });

      graph.on("blank:click", () => {
        _this.form = {};
        _this.tableData = [];
        _this.isConditionFlag = false;
        // _this.TaskConditionFlag = ;
        // this.formData = {}
        _this.$forceUpdate();
        if (!_this.form.type) {
          _this.controlFlag = false;
          _this.TaskConditionNode = false;
        }
      });
    },
    //选项窗口节点前清空值
    clearOpenOption(){
        this.question = "";
        this.answer = "";
        this.analysis = "";
        this.checkBox.forEach((item) => {
          this.$set(item,'value','')
          this.$set(item,'isCheck',false)
        });
    },
    //点击元件操作
    isActiveTypeFn() {
      if (this.form.TaskActionChild == 'TaskActionElement') {  //元件操作
        let nodeData = this.thisNode.getData();
        this.form.elementOperation = nodeData.elementOperation
        this.tiggertargetPath = nodeData.targetPath
        setTimeout(()=>{
              this.$refs.triggerElement.filterDataTigger=''
              this.$refs.triggerElement.filterDataTigger=this.tiggertargetPath
              this.$refs.triggerElement.checkNode(this.tiggertargetPath)
        },200)



      }
      if (this.form.TaskActionChild == 'TaskActionTeachingAim') { 
        let nodeData = this.thisNode.getData();
        
        if(nodeData.hasOwnProperty('aims')){
                this.aimsArr = []
                let aimsArr = nodeData.aims.split(',')
                  aimsArr.forEach(item=>{
                    let obj =  {
                        id:uuid(),
                        value:item
                    }
                    this.aimsArr.push(obj)
                  })

        } 



      }
      if (this.form.TaskActionChild == 'TaskActionOpenTask') {  //元件操作
        let nodeData = this.thisNode.getData()
        let data = []
        if (!nodeData.chooses) return
        data = nodeData.chooses
        if (data) {
          data = data.split(",")
          data = data.map(item => {
            return {
              id: uuid(),
              value: item,
            }
          })

        }


        this.addActionTasksList = data
      }

      if(this.form.TaskActionChild=='TaskActionLog'){ //日志
        let nodeData = this.thisNode.getData()
        this.form.logInfo = nodeData.logInfo
      }

    },
    getTaskJson() {
      return graph.toJSON();
    },
    getTaskTree() {
      const rootNodes = graph
        .getRootNodes()
        .map((item) => item.id)
        .map((item) => {
          return {
            pid: 0,
            id: item,
            children: [],
          };
        });

      const graphMap = graph
        .getCells()
        .map((item) => item.toJSON())
        .filter((item) => item.shape === "dag-edge")
        .reduce((pre, next) => {
          if (pre[next.source.cell]) {
            pre[next.source.cell].push(next.target.cell);
            return pre;
          }
          pre[next.source.cell] = [next.target.cell];
          return pre;
        }, {});

      const buildTree = (node) => {
        let childArr = graphMap[node.id] ?? [];
        for (let index = 0; index < childArr.length; index++) {
          const id = childArr[index];
          let obj = {
            pid: node.id,
            id,
            children: [],
          };
          node.children.push(obj);
          buildTree(obj);
        }
        return node;
      };

      const trees = rootNodes.map((item) => buildTree(item));

      return trees;
    },
    updateValue(name, val) {
      this.$emit(`update:${name}`, val);
    },

    filterPerentId() {
      if (
        this.thisNode &&
        this.thisNode.getData() &&
        this.thisNode.getData().id
      ) {
        return this.thisNode.getData().id;
      } else {
        return "";
      }
    },
    addNode() {
      const id = new Date().getTime();
      let nodeChild;
      let node;
      if (this.thisNode && this.thisNode.getData) {
        if (
          this.thisNode.getData().type == "TaskActionNode" ||
          this.thisNode.getData().typeChild == "Action"
        ) {
          this.$store.dispatch("task/noNest");
          return;
        }
      }

      if (graph.getNodes().length <= 0) {
        nodeChild = {
          id,
          shape: "dag-node",
          parentId: this.filterPerentId(),
          type: "TaskRootNode",
          // isRoot:"TaskRootNode",
          data: {
            label: "节点",
            type: "TaskRootNode",
            parentId: this.filterPerentId(),
            typeChild: "TaskRootNode",
            // isRoot:"TaskRootNode"
          },
          ports: [
            {
              id: "1-1",
              group: "bottom",
            },
          ],
        };

        node = graph.addNode(nodeChild);
        this.thisNode = node;
      } else {
        nodeChild = {
          id,
          shape: "dag-node",
          parentId: this.filterPerentId(),
          data: {
            label: "节点",
            type: "TaskRootNode",
            parentId: this.filterPerentId(),
            typeChild: "TaskRootNode",
          },
          ports: [
            {
              id: "1-1",
              group: "bottom",
            },
          ],
        };
        node = graph.addNode(nodeChild);
        this.creatdaddEdge(node);
        this.thisNode = node;
      }

      if (this.form.id) {
        const findNode = graph
          .getNodes()
          .find((item) => item.id === this.form.id);
        const { x, y } = findNode.position();
        node.position(x + 250, y);
        graph.centerCell(node);
        return;
      }

      const roots = graph.getRootNodes();
      if (roots && roots.length > 0) {
        const { x, y } = roots[0].position();
        node.position(x + 200, y);
        graph.centerCell(node);
      }
    },
    //添加节点
    async addSelectNode(type) {
      switch (type) {
        case "TaskConditionNode": //条件节点
          let conditionlNode = await this.createChild();
          this.setChildPosion(conditionlNode);
          break;
      }
    },

    //设置创建的节点元素位置
    setChildPosion(setChildPosion) {
      setChildPosion.position(
        this.thisNode.position().x,
        this.thisNode.position().y
      );
      graph.centerCell(setChildPosion);
      this.creatdaddEdge(setChildPosion);
    },
    //创建子节点
    createChild() {
      const id = new Date().getTime();
      let nodeChild;
      let _this = this;
      //条件节点
      nodeChild = {
        id,
        shape: "polygon",
        label: "条件节点",
        width: 80,
        height: 80,
        typeChild: "TaskConditionNode",
        parentId: this.filterPerentId(),
        type: "TaskConditionNode",
        data: {
          label: "条件节点",
          type: "TaskConditionNode",
          typeChild: "TaskConditionNode",
          parentId: this.filterPerentId(),
        },
        attrs: {
          body: {
            fill: "#efdbff",
            stroke: "#9254de",
            refPoints: "0,10 10,0 20,10 10,20",
          },
        },
      };
      return graph.addNode(nodeChild);
    },
    //创建线
    creatdaddEdge(node) {
      graph.addEdge({
        source: {
          cell: this.thisNode,
          //  port: 'port_1'
        },
        target: {
          cell: node,
          // port: 'port_2'
        },
        router: {
          name: "orth",
        },
        attrs: {
          line: {
            stroke: "#000",
            strokeWidth: 1,
          },
        },
      });
    },

    removeEdge() {
      graph.removeEdge(this.checkedEdgeId);
      this.checkedEdgeId = "";
    },
    removeAllNode() {
      let nodesAll = graph.getNodes();
      for (let i = 0; i < nodesAll.length; i++) {
        graph.removeNode(nodesAll[i].id);
      }
    },
    removeNode() {
      graph.removeNode(this.form.id);
    },
    getCurrentTaskInfo() {
      const flowJsonData = this.getTaskJson();
      const flowMapData = this.flowMapData;
      const flowTriggerMap = this.flowTriggerMap;
      let taskInfo = Object.assign({}, this.taskInfo);
      taskInfo.flowMapData = flowMapData;
      taskInfo.flowJsonData = flowJsonData;
      taskInfo.flowTriggerMap = flowTriggerMap;
      const trees = this.getTaskTree();
      if (trees.length > 1) {
        this.$Msg("只能有一个根结点", "warning");
        return;
      }
      taskInfo.subTaskGraph = trees;

      taskInfo.subTaskList = flowJsonData.cells
        .filter((item) => item.shape === "dag-node")
        .map((item) => {
          const { data } = item;
          return {
            subTaskGuid: data.id,
            subTaskName: data.label,
            subTaskType: data.type,
            describe: data.description ?? "",
            trigger: flowTriggerMap[data.id],
            stepList: flowMapData[data.id]
              ? flowMapData[data.id].map((stepItem) => {
                return {
                  alias: stepItem.targetPath,
                  methodName: stepItem.templateName,
                  methodParams: [stepItem.defaultValue],
                  tnf_type: stepItem.type,
                  actor_template_id: stepItem.templateId,
                  runTime: stepItem.stepTime,
                  actionFormData: stepItem,
                };
              })
              : [],
          };
        });
      return taskInfo;
    },

    async save() {
      this.showExtDialog = false;
      this.$forceUpdate();
      let taskInfo = this.getCurrentTaskInfo();
      let datas = taskInfo.flowJsonData.cells.filter(
        (item) =>
          item.view == "vue-shape-view" || item.type == "TaskConditionNode"
      );

      let ary2 = JSON.parse(JSON.stringify(datas));
      ary2 =
        (await ary2) &&
        ary2.map((item, index) => {

          let {
            data,
            id,
            isRoot,
            label,
            parentId,
            type,
            typeChild,
            size,
            position,
          } = item;
          let items = {
            taskNodeID: data.id,
            parentId: data.parentId,
            taskNodeType: data.type,
            taskNodeName: data.label,
            taskNodeDesc: data.description,
            position,
            arg: {
              taskNodeID: data.id,
              taskNodeName: data.label,
              taskNodeDesc: data.description,
              logicConfig: this.logicConfig,
              parentId: data.parentId,
              taskNodeType: data.type,
              typeChild: data.typeChild,
            },
          };

          if (data.type == "TaskRootNode") {
            items.arg.taskMode = this.taskInfo ? this.taskInfo.taskMode : "";

            items.arg.taskEditor = this.taskInfo
              ? this.taskInfo.taskEditor
              : "";
            const sceneInfo = this.sceneList.find(item => item._id === this.taskInfo.taskEditor)
            items.arg.taskEditorName = sceneInfo ? sceneInfo.name : "";
            items.taskEditor = this.taskInfo ? this.taskInfo.taskEditor : "";
            items.taskEditorName = sceneInfo ? sceneInfo.name : "";

            items.arg.taskCourse = this.course
              ? this.course.children
                ? this.course.children[0].course
                : ""
              : "";
            items.arg.taskProject = this.taskInfo ? this.taskInfo.project : "";
            return items;
          } else if (data.type == "TaskActionNode") {
            //動作节点
            items.arg.targetPath = data.targetPath;
            items.arg.runTime = data.runTime;
            items.typeChild = data.TaskActionChild;
            items.arg.typeChild = data.TaskActionChild;

            if (data.TaskActionChild == "TaskActionCamera") {
              //摄像机动作节点
              // items.arg.TaskActionChild = data.TaskActionChild;
              (items.arg.camPos = data.camPos),
                (items.arg.camQuaternion = data.camQuaternion);
              items.arg.camMoveType = data.camMoveType;
              items.arg.camMoveTime = data.camMoveTime;
              return items;
            }


            if (
              data.TaskActionChild == "TaskActionHightLight" ||
              data.TaskActionChild == "TaskActionUnHightLight" ||
              data.TaskActionChild == "TaskActionCustom"
            ) {
              items.actionName = data.actionName;
              items.monitorParamValue = data.monitorParamValue;
              items.arg.actionName = data.actionName;
              items.arg.monitorParamValue = data.monitorParamValue;
              items.arg.camPos = data.camPos;
              items.arg.camQuaternion = data.camQuaternion;
              items.arg.camMoveType = data.camMoveType;
              items.arg.tipCon = data.tipCon;
              if (data.hasOwnProperty('paramValue')) items.arg.paramValue = data.paramValue;
              return items;
            }


            if (data.TaskActionChild == "TaskActionOpenOption") {  //打开选项窗口节点
              if (data.chooseA) items.arg.chooseA = data.chooseA;
              if (data.chooseB) items.arg.chooseB = data.chooseB;
              if (data.chooseC) items.arg.chooseC = data.chooseC;
              if (data.chooseD) items.arg.chooseD = data.chooseD;
              if (data.question) items.arg.question = data.question;  //问题
              if (data.answer) items.arg.answer = data.answer;     //答案
              if (data.analysis) items.arg.analysis = data.analysis;  //解析
              return items;
            }

            if (data.TaskActionChild == "TaskActionCloseOption") {  //关闭选项窗口节点
              if (data.chooseA) delete items.arg.chooseA
              if (data.chooseA) delete data.chooseA;
              if (data.chooseB) delete items.arg.chooseB
              if (data.chooseB) delete data.chooseB;
              if (data.chooseC) delete items.arg.chooseC
              if (data.chooseC) delete data.chooseC;
              if (data.chooseD) delete items.arg.chooseD
              if (data.chooseD) delete data.chooseD;
              if (data.question) delete items.arg.question
              if (data.question) delete data.question;
              if (data.answer) delete items.arg.answer
              if (data.answer) delete data.answer;
              if (data.analysis) delete items.arg.analysis
              if (data.analysis) delete data.analysis;
              return items;
            }



            if (data.TaskActionChild == "TaskActionOpenPage") {  //打开页面
              if (data.pageId) items.arg.pageId = data.pageId;
              if (data.pageInsKey) items.arg.pageInsKey = data.pageInsKey;
              if (data.baseUIPageUrl) items.arg.baseUIPageUrl = data.baseUIPageUrl;

              return items;
            }

            if (data.TaskActionChild == "TaskActionClosePage") {  //关闭页面
              if (data.pageId) delete items.arg.pageId
              if (data.pageId) delete data.pageId
              if (data.pageInsKey) delete items.arg.pageInsKey
              if (data.pageInsKey) delete data.pageInsKey
              if (data.baseUIPageUrl) delete items.arg.baseUIPageUrl
              if (data.baseUIPageUrl) delete data.baseUIPageUrl

              return items;
            }

            if (data.TaskActionChild == "TaskActionVideo") {  //打开视频

              if (data.videoName) items.arg.videoName = data.videoName;
              if (data.attachment_url) items.arg.resourceUrl = data.attachment_url[0] ? data.attachment_url[0].fullPath : "";
              if (data.videoTime) items.arg.videoTime = data.videoTime;
              return items;
            }

            if (data.TaskActionChild == "TaskActionCloseVideo") {  //关闭视频
              if (data.videoName) delete items.arg.videoName;
              if (data.videoName) delete data.videoName;
              if (data.resourceUrl) delete items.arg.resourceUrl;
              if (data.resourceUrl) delete resourceUrl.resourceUrl;
              if (data.videoTime) delete items.arg.videoTime;
              if (data.videoTime) delete data.videoTime;
              return items;
            }

            if (data.TaskActionChild == "TaskActionPlayPdf") {  //打开pdf
              if (data.resourceUrl) items.arg.resourceUrl = data.resourceUrl
              return items;
            }

            if (data.TaskActionChild == "TaskActionAudio") {  //打开音频
              if (data.attachment_url) items.arg.resourceUrl = data.attachment_url[0] ? data.attachment_url[0].fullPath : "";
              return items;
            }

            if (data.TaskActionChild == "TaskActionCloseAudio") {  //关闭音频
              if (data.resourceUrl) delete items.arg.resourceUrl
              if (data.resourceUrl) delete data.resourceUrl;
              return items;
            }

            if (data.TaskActionChild == 'TaskActionUI') {  //打开ui
              if (data.uiPanelName) items.arg.uiPanelName = data.uiPanelName
              return items;
            }

            if (data.TaskActionChild == 'TaskActionImage') {  //打开图片
              if (data.attachment_url) items.arg.resourceUrl = data.attachment_url[0] ? data.attachment_url[0].fullPath : "";
              // if (data.spriteName) items.arg.spriteName = data.spriteName
              if (data.spritePosition) items.arg.spritePosition = data.spritePosition
              if (data.spriteSize) items.arg.spriteSize = data.spriteSize
              return items;
            }

            if (data.TaskActionChild == "TaskActionElement") {   //元件操作节点
              if (data.hasOwnProperty('targetPath')) items.arg.targetPath = data.targetPath;
              if (data.hasOwnProperty('elementOperation')) items.arg.elementOperation = data.elementOperation;
              return items;
            }

            if (data.TaskActionChild == "TaskActionOpenTask") {   //动作节点任务选择界面
              if (data.hasOwnProperty('chooses')) items.arg.chooses = data.chooses;
              return items;
            }

            if (data.TaskActionChild == "TaskActionLog") {   //日志节点
              if (data.hasOwnProperty('logInfo')) items.arg.logInfo = data.logInfo;
              return items;
            }
            
            if (data.TaskActionChild == "TaskActionTeachingAim") {   //教学目标
                if (data.hasOwnProperty('aims')) items.arg.aims = data.aims;
               return items;
            }

            return items;
          } else if (data.typeChild == "TaskParallelNode") {
            //并行节点
            items.arg.targetPath = "";
            items.arg.subTaskType = "";
            return items;
            // TaskConditionClickObject
          } else if (data.type == "TaskConditionNode") {

            if (data.hasOwnProperty('targetPath')) items.arg.targetPath = data.targetPath;
            if (data.answer) items.arg.answer = data.answer;
            if (data.typeChild == "TaskConditionOpenPage") {   //打开页面
              if (data.hasOwnProperty('pageId')) items.arg.pageId = data.pageId;
              if (data.hasOwnProperty('pageInsKey')) items.arg.pageInsKey = data.pageInsKey;
              if (data.hasOwnProperty('checkComponentId')) items.arg.checkComponentId = data.checkComponentId;
              return items;
            }

            if (data.typeChild == "TaskConditionChooseModel") {   //模型选项
              if (data.hasOwnProperty('rightName')) items.arg.rightName = data.rightName;
              if (data.hasOwnProperty('json')) items.arg.json = data.json;
              return items;
            }


            if (data.typeChild == "TaskConditionExam") {   //考试任务
              if (data.hasOwnProperty('json')) items.arg.json = data.json;
              return items;
            }


            if (data.typeChild == "TaskConditionExamSettle") {   //考核结算
              if (data.hasOwnProperty('settleType')) items.arg.settleType = data.settleType;
              return items;
            }

            // TaskConditionExam


            if (data.typeChild == "TaskConditionTask") {   //任务选择
              if (data.hasOwnProperty('choose')) items.arg.choose = data.choose;
              return items;
            }



            return items;
          } else if(data.typeChild =='TaskSequenceNode'){   //顺序节点
                if (data.hasOwnProperty('teachingActivity')) items.arg.teachingActivity = data.teachingActivity;
               return items;
          }else{

            return items;
          }
        });
   
      (await ary2) &&
        ary2.forEach((e) => {
          let children = [];
          ary2.forEach((d, index) => {
            if (e.taskNodeID == d.parentId) {
              children.push(d);
            }
          });
          if (children.length > 0) {
            children.sort(function (a, b) {
              //升序
              if (a.position.x > b.position.x) {
                return 1;
              } else {
                return -1;
              }
            });

            e.children = children;
          }
        });

      let rootDatas = ary2.filter(
        (item) => item.taskNodeType == "TaskRootNode"
      );
      let jsonData = {
        node: rootDatas[0],
      };

      this.$store.dispatch("task/saveTask", taskInfo);
      console.log(jsonData, "jsonData");

      //插入节点组织树接口
      saveTreeJsonData({
        taskId: taskInfo ? taskInfo["_id"] : "",
        jsonData: JSON.stringify(jsonData) || "",
      }).then((res) => { });
    },
    // 生成规则文件字符方法
    async generateRuleStr() {
      if (!this.taskInfo.taskEditorRuleId) return;
      let editorId = this.taskInfo.taskEditor;
      let projectId = this.taskInfo.project;
      await this.$store.dispatch('editorDefinition/loadData', editorId)
      await this.$store.dispatch('editorType/loadData', projectId)
      let definitionMap = this.$store.state.editorDefinition.definitionMap;
      let typeMap = this.$store.state.editorType.typeMap
      await setConfigDatas({
        taskEditor: this.taskInfo.taskEditor,
      }).then((res) => {
        if (res.code == '200' && res.data) {
          if (!res.data.ruleDefinitionList) return;
          const configList =
            typeof res.data.ruleDefinitionList === 'object'
              ? res.data.ruleDefinitionList
              : JSON.parse(res.data.ruleDefinitionList);
          let rule = configList.find(ruleDef => ruleDef.id === this.taskInfo.taskEditorRuleId)
          this.logicConfig = rule.ruleDefinitionList.map(ruleIns => {
            return ruleIns.children.map(node => {
              if (node.type === 'signOfOperation') return node.name;
              let definition = definitionMap[node.structItemId];
              let type = typeMap[definition.deviceTypeId];
              let extList = type.extended_properties;
              let extName = extList.find(ext => ext.id = node.extId).name;
              return `_${definition.tag}_${type.name}.${extName}`;
            }).join('')
          }).join(";")
        }
      });
    },


    openFullScreen() {
      this.fullScreenStatus = true;
      this.$refs["form"].$el.requestFullscreen().then(() => {
        const dom = this.$refs.form.$el;
        this.flowHeight = dom.clientHeight;
      });
    },
    closeFullScreen() {
      this.fullScreenStatus = false;
      document.exitFullscreen().then(() => {
        this.flowHeight = 699;
      });
    },
    validate() {
      return true;
    },
    async handleDelete(index) {
      let result = await Swal.fire({
        title: "删除信息",
        text: `确认删除该步骤？`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        buttonsStyling: false,
      });

      if (!result.value) return;

      this.tableData.splice(index, 1);
      this.$notify({
        timeout: 1500,
        message: "删除成功",
        icon: "add_alert",
        horizontalAlign: "center",
        verticalAlign: "bottom",
        type: "success",
      });
    },
    async getTreeData(sceneId) {
      queryTreeData({
        sceneId,
      }).then((res) => {
        if (res.data) {
          //过滤方法是为了解决返回组织树 返回数组对象中存在一个空数组情况
          res.data.children =
            res.data &&
            res.data.children &&
            res.data.children.filter(
              (item) =>
                Object.prototype.toString.call(item) !== "[object Array]"
            );
          this.$store.dispatch("editor/setTreeData", [res.data]);
        }
      });
    },
    /** 获取编辑器保存的视角 */
    async getEditorPoistionList(sceneId) {
      queryCameraPositionList(sceneId).then((res) => {
        if (res.data) {
          this.$store.commit("editor/SET_CAMERA_POSITION_LIST", res.data);
        }
      });
    },
  },
  to() {
    let highBound = this.from + this.pagination.perPage;
    if (this.total < highBound) {
      highBound = this.total;
    }
    return highBound;
  },
  from() {
    return this.pagination.perPage * (this.pagination.currentPage - 1);
  },
  total() {
    return this.searchedData.length > 0
      ? this.searchedData.length
      : this.tableData.length;
  },
  mounted() {
    getTaskInfo(this.$route.params.id).then((res) => {
      this.taskInfo = res.data;
      console.log(this.taskInfo, "=====this.taskInfo");
      this.getTreeData(res.data.taskEditor);
      this.getEditorPoistionList(res.data.taskEditor);
      this.$store.dispatch("task/setTaskInfo", Object.assign({}, res.data));
      this.$store.dispatch("editor/refreshSceneList", {
        _id: res.data.project,
      });
      this.init();
      this.initStepMapData();
      this.initFlow(res.data);
      this.generateRuleStr();
    });
  },
  watch: {
    form: {
      deep: true,
      handler: function (val) {
        const emptyObj = (obj) => {
          for (let property in obj) {
            return false;
          }
          return true;
        };
        if (emptyObj(val)) {
          return;
        }
        const cell = graph.getCellById(val.id);
        if (cell) {
          cell.setData(val);
        }
        if (this.form.type && this.form.type == "TaskConditionNode") {
          this.thisNode.prop((this.thisNode.label = val.label));
        }
        if (this.form.type && this.form.type == "TaskActionNode") {
          this.thisNode.getData().typeChild = "TaskActionNode";
          //  this.thisNode.getData().isRoot="TaskActionNode"
        }


        if (this.form.TaskActionChild == 'TaskActionImage') {
          this.thisNode.setData({  "spritePosition": [this.form.spritePositionx, this.form.spritePositiony], "spriteSize": [this.form.spriteSizeWidth, this.form.spriteSizeHeight] })
        }
        if(this.form.TaskActionChild=='TaskActionLog'){
          this.thisNode.setData({logInfo:this.form.logInfo})
        }
      },
    },
    "rightData": {
      handler(newValue, oldValue) {
        this.thisNode.setData({ "rightName": this.rightName, 'json': JSON.stringify(newValue) })
      },
      deep: true
    },
    'addActionTasksList': {
      handler(newValue, oldValue) {
        let data = newValue.map(item => item.value)
        if (!data) return
        this.thisNode.setData({ "chooses": data.join(",") })
      },
      deep: true
    },
    'aimsArr':{
        handler(newValue, oldValue) {
          let strArr = []
            newValue&&newValue.forEach(item=>{
               if(item.value){
                strArr.push(item.value)  
               }
            })
            if(strArr.length<=0){

              this.thisNode.setData({'aims': strArr.join('') })
              return
            }
              this.thisNode.setData({'aims': strArr.join(',') })
        },
        deep: true
    }
  },
};
</script>
<style lang="css" scoped>
*:fullscreen,
*:-webkit-full-screen,
*:-moz-full-screen {
  background-color: rgba(255, 255, 255, 1);
}

.md-toolbar {
  color: #808990 !important;
  padding: 1px 15px;
  border-radius: 1px;
  position: static;
  border-bottom: 1px solid rgb(0 0 0 / 3%);
}

.md-tree {
  padding: 15px 15px;
}

.md-collapse {
  padding-left: 15px;
}

.span {
  min-width: 60px;
  margin: 30px;
  display: inline-block;
  text-align: center;
}

.md-card {
  margin: 0px;
  box-shadow: 0 0 0 0 rgb(0 0 0 / 14%);
}

.md-card .md-card-actions {
  border-top: 0px;
}

.md-card .md-card-content {
  padding: 25px 0px;
}

.md-card .md-card-content .extprop {
  padding-top: 0px !important;
}

.md-icon-text-button {
  width: 80px;
}

.md-dialog /deep/.md-dialog-container {
  padding: 30px;
  min-width: 650px;
  min-height: 650px;
}

.md-collapse-content {
  padding: 0px 0px;
}

.md-collapse-content .cols-extprop {
  padding: 0px 0px;
}

.md-collapse-content p {
  padding-top: 12px;
}

.md-form-label-ext {
  padding-top: 25px;
}

/deep/ .OpenOptionCondition .md-radio-label{
  margin-top: -7px;
}

/*#container{left:0 !important; top:0 !important;}*/
</style>
